"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subtitle = _styledComponents.default.div.withConfig({
  displayName: "Subtitle",
  componentId: "sc-1t26tiu-0"
})(["margin:0;font-size:0.875rem;font-weight:", ";line-height:1.5;"], (0, _helpers.fontWeight)('regular'));

var _default = Subtitle;
exports.default = _default;